<ng-container>
    @if (data.showCloseIcon) {
        <div class="flex flex-col text-end">
            <fa-icon
                class="ml-4 cursor-pointer text-custom-dark-grey"
                size="xl"
                [icon]="['far', 'close']"
                [mat-dialog-close]="true"
                (click)="onClick(ModalResultEnum.CLOSE)" />
        </div>
    }
    <div class="flex flex-col">
        @if (data.closeAction) {
            <fa-icon
                class="self-end mr-4 cursor-pointer text-custom-dark-grey"
                size="xl"
                [icon]="['far', 'close']"
                [mat-dialog-close]="true" />
        }
        <fa-icon
            class="flex justify-center grow"
            size="5x"
            [class]="{
                'text-custom-green': data.type === ModalType.SUCCESS,
                'text-error': data.type === ModalType.ERROR || data.type === ModalType.DANGER,
                'text-secondary':
                    data.type === ModalType.INFO || data.type === ModalType.WARNING || data.type === ModalType.QUESTION,
            }"
            [icon]="['fat', iconName]" />
        <p class="!my-6 text-xl text-center text-black">
            {{ data.title }}
        </p>
        @if (data.description) {
            <p
                class="text-center whitespace-pre-line"
                mat-dialog-content>
                {{ data.description }}
            </p>
        }
        <div
            class="flex justify-around"
            mat-dialog-actions>
            @if (data.cancelLabel) {
                <app-button
                    [icon]="data.cancelIcon ?? undefined"
                    [label]="data.cancelLabel"
                    [type]="
                        data.type === ModalType.ERROR || data.type === ModalType.DANGER
                            ? ButtonType.ALERT_SECONDARY
                            : ButtonType.SECONDARY
                    "
                    (onClick)="onClick(ModalResultEnum.CANCEL)" />
            }
            <app-button
                [icon]="data.confirmIcon && !isLoading() ? data.confirmIcon : undefined"
                [label]="isLoading() ? '' : data.confirmLabel"
                [loading]="isLoading()"
                [type]="
                    data.type === ModalType.ERROR || data.type === ModalType.DANGER
                        ? ButtonType.ALERT
                        : ButtonType.PRIMARY
                "
                (onClick)="onConfirmClick()" />
        </div>
    </div>
</ng-container>
